import { signupApi } from '@saucelabs/sl-util-axios';

export const getCordToken = () => (
  signupApi.get('/api/cord-token')
);

export const getUserAttributes = () => (
  signupApi.get('/api/user-attributes')
);
